import React from "react";
import { StyledDetailsAccordion } from "./_styled";
import { ACCORDION_ANIMATION_TIMEOUT } from "../../../constants/ui";

export default function evidenceDetailsProcessor() {
  const evidenceDetails = (children) => {
    return (
      <>
        <StyledDetailsAccordion
          variant="secondary"
          toggleText="Details"
          data-testid="evidence-details"
          timeout={ACCORDION_ANIMATION_TIMEOUT}
          padding={false}
        >
          {children}
        </StyledDetailsAccordion>
      </>
    );
  };

  return { evidenceDetails };
}
